import React from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import themeColor from "../../../styles/themeColor";

const buttonTextStyle = {
  fontSize: "0.9rem",
  letterSpacing: 0,
  color: themeColor.textColor,
  background: "transparent",
  // width: "20%",
  outline: "none",
};

const LoginButton = withRouter((props) => {
  const { style, history, location } = props;
  const { t } = useTranslation();

  return (
    <div style={{ ...style }}>
      <button
        style={{
          textAlign: "right",
          border: "none",
          outline: "none",
          ...buttonTextStyle,
        }}
        onClick={() => {
          history.push({
            pathname: "/staff/login",
            state: { previousScreen: location.pathname },
          });
        }}
      >
        {t("authentication.staffLogin")}
      </button>
    </div>
  );
});

export default LoginButton;
